'use strict';

var AxiosURLSearchParams = require('../../../helpers/AxiosURLSearchParams');

module.exports = typeof URLSearchParams !== 'undefined' ? URLSearchParams : AxiosURLSearchParams;



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/platform/browser/classes/URLSearchParams.js
// module id = 688
// module chunks = 0